import React from "react";
import Layout from "../../components/Layout";
import StyleGuidePage from "./StyleGuidePage";

const StyleGuide: React.FC = () => (
  <Layout>
    <StyleGuidePage />
  </Layout>
);

export default StyleGuide;
export * from "./StyleGuidePage";
